'use strict';

exports.__esModule = true;
var headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

exports.default = headers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/defaultHeaders.js
// module id = 685
// module chunks = 0